export const isValidEmail = (email: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const isValidPassword = (password: string) => {
  return (
    password.trim() !== '' &&
    password.length >= 8 &&
    /[A-Z]/.test(password) &&
    /[a-z]/.test(password) &&
    /\d/.test(password) &&
    /[!@#$%^&*()_+{}\]:;<>,.?~\\/-]/.test(password)
  );
};

export const isEmptyPassword = (password: string) => {
  return password.trim() === '';
};

export const isValidPhoneNumber = (value: string) => {
  const phoneRegex = /^\d+$/;

  if (!value.trim()) {
    return 'Phone number is required';
  } else if (!phoneRegex.test(value)) {
    return 'Invalid phone number. Please enter a valid phone number';
  } else if (value.length !== 11) {
    return 'Phone number must be 11 digits';
  }
  return true;
};
